import React from "react"
import { mapDispatchProps, mapStateToProps } from "../../../store/store"
import { connect } from "react-redux"
import { X } from "react-feather"
import Divider from "../../../components/divider"
import dayjs from "../../../plugins/dayjs"
import Button from "../../../components/button"
import { debounce } from "../../../helpers/debounce"
import SnsPaymentCancelConfirm from "./cancel/confirm"
import { SNS_PAYMENT_TYPE } from "../../../api/repositories/snsPayments"
import { useLanguage } from "@languages/index"

interface Props {
  className?: string
  onClick?: any

  style?: any
  history?: any
  preferences?: any

  auth?: any
  brand?: any
  settings?: any

  setPopup?: (params?: any) => void
  showSheet?: (params?: any) => void
  showOverlays?: (params?: any) => void
  closeOverlays?: () => void
}

const SnsPaymentBills = (props: Props) => {
  const language = useLanguage()
  const languageTexts = { ...language.common, ...language.pages.sns }
  const showCancelConfirm = () => {
    props.closeOverlays()
    debounce(() => {
      props.showOverlays({
        content: () => <SnsPaymentCancelConfirm />,
      })
    }, 400)
  }

  let containerStyle = ""
  if (props.preferences.isMobile) {
    containerStyle = "flex flex-col bg-white py-10 px-5 overflow-scroll min-w-[100vw]"
  } else {
    containerStyle = "flex flex-col bg-white rounded-2xl overflow-visible w-[480px] px-10 py-10"
  }

  return (
    <div className={`${containerStyle}`}>
      <div className="flex flex-row justify-between mb-9">
        <span className="font-bold text-xl tracking-tighter">{languageTexts.bills}</span>
        <span
          className="text-sm tracking-tighter underline cursor-pointer"
          onClick={() => {
            props.closeOverlays()
          }}
        >
          <X />
        </span>
      </div>

      <div className="flex flex-row justify-between">
        <div className="flex flex-col justify-start">
          {props.history.type == SNS_PAYMENT_TYPE.SINGLE ? (
            <span className="font-bold text-sm tracking-tighter">{languageTexts.payments_bills_text_1}</span>
          ) : (
            <span className="font-bold text-sm tracking-tighter">{languageTexts.payments_bills_text_2}</span>
          )}
        </div>

        {props.history.type == "SINGLE" ? (
          <div className="flex flex-col justify-center gap-1">
            <span className="font-bold text-sm tracking-tighter text-right">
              {languageTexts._amount(props.history.amount)}
            </span>
            <span className="font-bold text-sm tracking-tighter text-right text-[#ED8E00]">
              {languageTexts._price_per_1ea(props.history.price.toLocaleString(), props.settings.currencyText)}
            </span>
          </div>
        ) : (
          <div className="flex flex-col justify-center gap-1">
            <span className="font-bold text-sm tracking-tighter text-right">
              {languageTexts._amount(props.history.amount)}
            </span>
            <span className="font-bold text-sm tracking-tighter text-right text-[#ED8E00]">
              {`(${props.history.priceTotal.toLocaleString()}${languageTexts._currency(props.settings.currencyText)})`}
            </span>
          </div>
        )}
      </div>

      <Divider style={{ borderColor: "rgba(0,0,0,0.1)" }} className="my-5" />

      {/* 일회성 제품 시딩 구매 내역 */}
      {props.history.type == SNS_PAYMENT_TYPE.SINGLE ? (
        <div className="flex flex-col">
          <div className="flex flex-row justify-between">
            <div className="flex flex-col justify-start">
              <span className="font-bold text-sm tracking-tighter">{languageTexts.paid_date}</span>
            </div>

            <div className="flex flex-col justify-center gap-1">
              <span className="font-bold text-sm tracking-tighter text-right">
                {`${dayjs(props.history.createdAt).format("YYYY-MM-DD hh:mm")}`}
              </span>
            </div>
          </div>
        </div>
      ) : null}

      {/* 시딩 패스 구매 내역*/}
      {props.history.type == SNS_PAYMENT_TYPE.MONTHLY || props.history.type == SNS_PAYMENT_TYPE.YEARLY ? (
        <div className="flex flex-col gap-[0.625rem]">
          <div className="flex flex-row justify-between">
            <div className="flex flex-col justify-start">
              <span className="font-bold text-sm tracking-tighter">{languageTexts.last_paid_date}</span>
            </div>

            <div className="flex flex-col justify-center gap-1">
              <span className="font-bold text-sm tracking-tighter text-right">
                {`${dayjs(props.history.createdAt).format("YYYY-MM-DD hh:mm")}`}
              </span>
            </div>
          </div>
          <div className="flex flex-row justify-between">
            <div className="flex flex-col justify-start">
              <span className="font-bold text-sm tracking-tighter">
                {props.history.isSeedingPassCancel ? languageTexts.expiration_date : languageTexts.next_payment_date}
              </span>
            </div>

            <div className="flex flex-col justify-center gap-1">
              <span className="font-bold text-sm tracking-tighter text-right">
                {`${dayjs(props.history.expiresAt).add(1, "day").format("YYYY-MM-DD 09:00")}`}
              </span>
            </div>
          </div>
        </div>
      ) : null}

      <Divider style={{ borderColor: "rgba(0,0,0,0.1)" }} className="my-5" />

      <div className="flex flex-row justify-between">
        <div className="flex flex-col justify-start">
          <span className="font-bold text-sm tracking-tighter">{languageTexts.payment_method}</span>
        </div>

        <div className="flex flex-col justify-center gap-1">
          <span className="font-bold text-sm tracking-tighter text-right">
            {props.history.purchasedMethod ? props.history.purchasedMethod.split(",")[0].trim() : ""}
          </span>
          <span className="text-sm tracking-tighter text-right opacity-50">
            {props.history.purchasedMethod ? props.history.purchasedMethod.split(",")[1].trim() : ""}
          </span>
        </div>
      </div>

      <Divider style={{ borderColor: "rgba(0,0,0,0.1)" }} className="my-5" />

      <div className="flex flex-row justify-between">
        <div className="flex flex-col justify-start">
          <span className="font-bold text-sm tracking-tighter">{languageTexts.total_price}</span>
        </div>

        <div className="flex flex-col justify-center gap-1">
          <span className="font-bold text-sm tracking-tighter text-right">
            {languageTexts._price(
              (props.history.amount * props.history.price * 1.1).toLocaleString(),
              props.settings.currencyText
            )}
          </span>
          <span className="font-bold text-sm tracking-tighter text-right opacity-50">
            {`(${props.history.price.toLocaleString()}*${props.history.amount.toLocaleString()}) + VAT(10%)`}
          </span>
        </div>
      </div>

      {(props.history.type == SNS_PAYMENT_TYPE.MONTHLY || props.history.type == SNS_PAYMENT_TYPE.YEARLY) &&
      props.brand.isSnsPassAutoPurchaseEnabled ? (
        <div className="mt-5">
          <Button
            bordered
            borderColor={"BLACK"}
            text={languageTexts.payments_bills_text_3}
            onClick={() => {
              showCancelConfirm()
            }}
          />
        </div>
      ) : null}
    </div>
  )
}

export default connect(mapStateToProps, mapDispatchProps)(SnsPaymentBills)
